import {schema} from 'normalizr';

export const facility = new schema.Entity('facilities');

export const documentation = new schema.Entity('documentation');

export const patient = new schema.Entity('patients', {
  documentation: [documentation],
  period: new schema.Entity('periods')
});

export const facilityStatus = new schema.Entity('facilityStatus', {}, {
  idAttribute: value => `${value.periodId}/${value.nursingFacilityId}`
});


export const reviewPeriod = new schema.Entity('periods', {
  data: [patient],
  facilityStatuses: [facilityStatus]
}, {
  processStrategy: entity => ({
    ...entity, facilityStatusesData: entity.facilityStatuses
  })
});


export const reviewer = new schema.Entity('reviewers');

export const MQD = new schema.Entity('MQDs');

export const notification = new schema.Entity('notifications');

export const irrs = new schema.Entity('irrs');




// WEBPACK FOOTER //
// ./src/store/schema.js